import { useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes
import useLocales from 'src/hooks/useLocales';
// components
import CustomerNewEditForm from './CustomerNewEditForm';
import useSettings from 'src/hooks/useSettings';
import Page from 'src/components/Page';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { PATH_DASHBOARD } from 'src/routes/paths';
// ----------------------------------------------------------------------

export default function CustomerCreate() {
  const { themeStretch } = useSettings();
  const { pathname } = useLocation();
  const { translate } = useLocales();
  const isEdit = pathname.includes('edit');

  return (
    <Page title={translate('Customer.CreateTitle')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('Customer.CreateCustomer')}`
              : `${translate('Customer.UpdateCustomer')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            { name: `${translate('Customer.CustomerList')}`, href: PATH_DASHBOARD.Customer.list },
            {
              name: !isEdit
                ? `${translate('Customer.NewCustomer')}`
                : `${translate('Customer.UpdateEmp')}`,
            },
          ]}
        />
        <CustomerNewEditForm />
      </Container>
    </Page>
  );
}
